import { localApi } from '../utils/axios';

// 获取学生仪表盘统计数据
export const getStudentDashboardStats = async () => {
  try {
    const response = await localApi.get('/student/dashboard/stats');
    return response.data.data || {};
  } catch (error) {
    console.error('获取学生统计数据失败:', error);
    throw error;
  }
};

// 获取学生待完成练习列表
export const getStudentPendingExercises = async (limit = 5) => {
  try {
    const response = await localApi.get('/student/dashboard/pending-exercises', { params: { limit } });
    return response.data.data || [];
  } catch (error) {
    console.error('获取待完成练习失败:', error);
    throw error;
  }
};

// 获取学生最近活动记录
export const getStudentRecentActivities = async (limit = 5) => {
  try {
    const response = await localApi.get('/student/dashboard/recent-activities', { params: { limit } });
    return response.data.data || [];
  } catch (error) {
    console.error('获取最近活动失败:', error);
    throw error;
  }
}; 